<template>
  <div id="app" :class="featureCodes">
    <transition :name="transitionCode">
      <keep-status :isDestroy="isDestroy">
        <router-view></router-view>
      </keep-status>
    </transition>
  </div>
</template>

<script>
  import globalShare from "./utils/globalShare.ts";
  import keepAlive from "./views/modules/keep-alive.js";
  export default {
    name: "App",
    data() {
      return {
        transitionCode: "",
        isDestroy: false,
      };
    },
    computed: {
      featureCodes() {
        let codes = [];
        if (this.isWeiXin()) {
          codes.push("wechat");
        } else if (this.isApp()) {
          codes.push("lchapp");
        } else {
          codes.push("h5");
        }
        return codes.join(" ");
      },
    },
    methods: {
      isWeiXin() {
        let userAgent = window.navigator.userAgent;
        if (userAgent.toLowerCase().match(/MicroMessenger/i) == "micromessenger") {
          return true;
        } else {
          return false;
        }
      },
      isApp() {
        return window.lch_device_info != undefined;
      },
    },
    watch: {
      $route(to, from) {
        this.isDestroy = globalShare.isDestroy;
        this.transitionCode = globalShare.transitionCode;
      },
    },
    components: {
      "keep-status": keepAlive,
    },
  };
</script>

<style lang="less">
  #app {
    font-family: "Open Sans", -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, Segoe UI, Arial, Roboto, "PingFang SC", "miui", "Hiragino Sans GB", "Microsoft Yahei", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    .slide-right-enter-active,
    .slide-right-leave-active,
    .slide-left-enter-active,
    .slide-left-leave-active {
      will-change: transform;
      transition: all 400ms;
      // position: absolute;
    }
    .slide-right-enter {
      // opacity: 0;
      transform: translate3d(-100%, 0, 0);
    }
    .slide-right-leave-active {
      // opacity: 0;
      transform: translate3d(100%, 0, 0);
    }
    .slide-left-enter {
      // opacity: 0;
      transform: translate3d(100%, 0, 0);
    }
    .slide-left-leave-active {
      // opacity: 0;
      transform: translate3d(-100%, 0, 0);
    }
  }
  // .headShim {
  //   height: 0.8rem;
  // }
  .wechat,
  .lchapp {
    .shim {
      display: none;
    }
  }
  .lchapp,
  .h5 {
    .van-calendar > .van-calendar__header {
      margin-top: 80px;
      box-shadow: none;
    }
    .van-popup__close-icon--top-right {
      top: 100px !important;
    }
    .van-popup-slide-bottom-enter-to {
      transition: transform 0s !important;
    }
  }
  .wechat {
    position: absolute;
    top: -0.6rem;
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>
